const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20cinematic%20abstract%20thriller%20visual%2C%20dramatic%20orange%20and%20gold%20lighting%2C%20suspenseful%20mood%2C%20artistic%20film%20atmosphere%2C%20clean%20minimal%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-01-2026&orientation=landscape',
    title: '暗夜追踪',
    category: '动作悬疑',
    rating: '9.2',
    views: '128万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20romantic%20abstract%20cinematic%20visual%2C%20soft%20golden%20hour%20lighting%2C%20gentle%20emotional%20atmosphere%2C%20artistic%20love%20story%20mood%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-02-2026&orientation=landscape',
    title: '春风十里不如你',
    category: '都市爱情',
    rating: '8.8',
    views: '96万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20epic%20abstract%20fantasy%20visual%2C%20dramatic%20golden%20and%20amber%20lighting%2C%20grand%20cinematic%20atmosphere%2C%20artistic%20adventure%20mood%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-03-2026&orientation=landscape',
    title: '苍穹之巅',
    category: '科幻冒险',
    rating: '9.0',
    views: '156万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20nostalgic%20abstract%20period%20drama%20visual%2C%20soft%20vintage%20golden%20lighting%2C%20elegant%20classical%20atmosphere%2C%20artistic%20historical%20mood%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-04-2026&orientation=landscape',
    title: '长安十二时辰',
    category: '古装历史',
    rating: '9.5',
    views: '210万',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warm%20playful%20abstract%20comedy%20visual%2C%20bright%20golden%20and%20amber%20lighting%2C%20lighthearted%20atmosphere%2C%20artistic%20entertainment%20mood%2C%20clean%20composition%2C%20no%20text%20no%20people&width=800&height=450&seq=media-05-2026&orientation=landscape',
    title: '欢乐喜剧人',
    category: '综艺喜剧',
    rating: '8.5',
    views: '89万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            全网热播影视精选，高清流畅不卡顿
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {mediaItems.map((item, i) => (
            <article key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-white transition-all shadow-lg">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-medium">
                  {item.rating}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {item.rating}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}